import { useContext } from 'react';
import { authContext } from './authContext';
/**
 * Access auth data (ie user's account)
 *
 * @private
 */
export const useAuthInternal = () => {
    const val = useContext(authContext);
    if (!val) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return val;
};
